import { api } from "..";
import { SimpleSuccessResponse } from "./types";

export const unmuteChat = async (
  chatId: number
): Promise<SimpleSuccessResponse> => {
  const res = await api.client.delete(`/chats/${chatId}/mute`);
  return res.data;
};
